import {
  Box,
  Grid,
  GridProps, Tooltip, tooltipClasses, TooltipProps
} from "@mui/material";

import { styled } from "@mui/material/styles";

export const CardProgressBox = styled(Grid)<GridProps & { $profilePage:boolean } >(({ theme }) => ({
  background: theme.customColors.backgroundCard,
  borderRadius: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  maxHeight: "50rem",
  //padding: theme.spacing(3),

  [`${theme.breakpoints.down("sm")}`]: {
    padding: theme.spacing(2)
  }

})) ;

export const CardProgressItemsBox = styled(Grid)<GridProps>(({ theme }) => ({
  height:"220px",
  width:"210px",

  alignItems:"center",
  display:"flex",
  flexDirection:"column",
  gap:theme.spacing(3),
  justifyContent:"center",
  margin:"auto",
  position:"relative"

}));

export const StyledPercentageItem = styled(Box)<{
  $left:string,
  $right:string,
}>(({
  $left,
  $right
}) => {
  return {
    left:$left,
    position:"absolute",
    right:$right,

    display:"flex",
    flexDirection:"column",
    zIndex:1,

    ".progress-left":{
      transform:"scaleX(-1);"
    },

    ".centered":{
      transform:"translateX(-14px)"
    }

  };});

export const StyledTitleSummary = styled(Grid)<GridProps>(({ theme }) => ({
  alignItems:"center",
  color:theme.customColors.textPrimary,
  display:"flex",
  flexDirection:"column",
  fontSize:theme.spacing(3.5),
  fontWeight:700,
  justifyContent:"flex-end",

  height:"80%",

  "span":{
    fontSize:theme.spacing(1.6),
    fontWeight:400,
    paddingBottom: "10px"
  }
})) ;

export const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip { ...props } classes={ { popper: className } } />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.arrow}::before`]: {
    border: `1px solid ${theme.customColors.border}`,
    backgroundColor: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: theme.customColors.backgroundCard,
    border: `1px solid ${theme.customColors.border}`,
    borderRadius: theme.spacing(1),
    color: theme.customColors.textWidget,
    fontSize: "0.75rem",
    maxWidth: "240px",
    padding: theme.spacing(1),
    textAlign: "center"
  }
}));
